<template>
  <div class="__fieldset" :class="type == 'block' ? '__block' : ''">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'inline'
    },
  },
};
</script>

<style lang="scss" scoped>
.__fieldset {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 24px;

  > .__field:only-child {
    flex: 0 0 70%;
    @media screen and (max-width: 960px) {
      flex: 1 1 auto;
    }
  }

  > .__block:only-child {
    flex: 0 0 100%;
    @media screen and (max-width: 960px) {
      flex: 1 1 auto;
    }
  }

  > * {
    flex: 1 1 360px;
  }
  
  .__field {
    &:first-child {
      .__label {
        padding: 0px 0px 12px 0px;
      }
    }
  }

  &.__block {
    display: flex;
    flex-direction: row !important;
    flex-wrap: nowrap;
  }
}
</style>
